import {request} from './client.js'

/**
 * @param {{unread?: boolean, category?: import('./types.js').NotificationCategory}} [filters]
 * @return {Promise<{notifications: import('./types.js').VsNotification[]}>}
 */
export function listNotifications(filters = {}) {
    const qs = new URLSearchParams()
    if (filters.unread)
        qs.set('unread', '1')
    if (filters.category)
        qs.set('category', filters.category)
    const suffix = qs.toString() ? `?${qs}` : ''
    return request('GET', `/notifications${suffix}`)
}

/**
 * @param {string} id
 */
export function markNotificationRead(id) {
    return request('POST', `/notifications/${id}/read`)
}

/**
 * @param {{endpoint: string, keys: {p256dh: string, auth: string}, userAgent: string}} subscription
 */
export function subscribePush(subscription) {
    return request('POST', '/notifications/subscribe', {body: subscription})
}

/**
 * @param {string} subscriptionId
 */
export function unsubscribePush(subscriptionId) {
    return request('POST', '/notifications/unsubscribe', {body: {subscriptionId}})
}
